import { PublicClientApplication } from '@azure/msal-browser';

export const msalPublicClientApplication = new PublicClientApplication({
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID ?? '',
  },
});
